import { useGetStatuses } from "security-app/hooks/useInvestigationsAPI";
import { SECURITY_EVENT_STATUSES } from "security-app/hooks/api/securityEventsAPI.types";
function useStatusMap() {
  const { statuses } = useGetStatuses();
  return Object.fromEntries(
    Object.keys(SECURITY_EVENT_STATUSES).map((key) => {
      var _a, _b, _c, _d;
      if (key === "INVESTIGATING")
        return [key, ((_a = statuses.find((status) => status.status === "Investigating")) == null ? void 0 : _a.status) || null];
      if (key === "FALSE_POSITIVE")
        return [key, ((_b = statuses.find((status) => status.status === "False Positive")) == null ? void 0 : _b.status) || null];
      if (key === "CLOSED")
        return [key, ((_c = statuses.find((status) => status.status === "Closed")) == null ? void 0 : _c.status) || null];
      return [key, ((_d = statuses.find((status) => status.default)) == null ? void 0 : _d.status) || null];
    })
  );
}
export default useStatusMap;
